import type { Artist, StudioLocation } from '../../api/client';

export type BookingEntryRoute = 'booking-location' | 'artist-select' | 'booking-date';

export function defaultActiveLocation(locations: StudioLocation[]): StudioLocation | null {
  const active = locations.filter((location) => location.active);
  return active.find((location) => location.default) || active[0] || null;
}

export function bookingArtistAssignment(artists: Artist[], artistSelectionEnabled: boolean): {
  artist: Artist | null;
  artistId: string | null;
  artistPreference: 'help_me_choose';
} {
  const active = artists.filter((artist) => artist.active);
  const artist = !artistSelectionEnabled && active.length === 1 ? active[0] : null;
  return { artist, artistId: artist?.id || null, artistPreference: 'help_me_choose' };
}

export function bookingEntryRoute(input: {
  locationSelectionEnabled: boolean;
  artistSelectionEnabled: boolean;
  locations: StudioLocation[];
}): BookingEntryRoute {
  const activeLocations = input.locations.filter((location) => location.active);
  if (input.locationSelectionEnabled && activeLocations.length > 1) return 'booking-location';
  return input.artistSelectionEnabled ? 'artist-select' : 'booking-date';
}
